import { clsx } from "clsx";
import { AutoComplete } from "primereact/autocomplete";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useEffect, useMemo, useRef, useState } from "react";
import { useAppContext } from "../Appcontext";
function ResultInput() {
  const { JSONBranchData, tickData, loadData, currentValueInput } =
    useAppContext();
  const dataJSON = JSONBranchData.map((item) => ({
    ...item,
    fullClassName: `${item.class} - ${item.fullName}`,
  }));

  const [inputData, setInputData] = useState("");
  const findStudent = useMemo(() => {
    return dataJSON?.find((item) => `${item.VNEDUID}` === currentValueInput);
  }, [dataJSON, currentValueInput]);

  const inputRef = useRef(null);

  const [items, setItems] = useState([]);
  const search = (event) => {
    if (!dataJSON) return;
    const query = event.query.toLowerCase().trim();
    // lọc các bản ghi có fullName chứa query
    const results = dataJSON.filter((item) =>
      item.fullName?.toLowerCase().includes(query)
    );
    // set danh sách kết quả hiển thị (tuỳ bạn muốn hiển thị gì, ví dụ fullName)
    setItems(results.map((item) => item));
  };

  const [valueSearch, setValueSearch] = useState("");

  return (
    <div>
      <div className="flex items-center relative">
        <div className={clsx(" absolute top-8 left-4 opacity-0", "checkmark")}>
          ✔
        </div>
        <p
          className={clsx(
            "mt-4 text-lg text-center my-2 py-2 flex-1",
            currentValueInput
              ? findStudent && findStudent.isRegister
                ? "bg-green-100"
                : "bg-red-100"
              : ""
          )}
        >
          Số: {currentValueInput}{" "}
          <span className="font-semibold">
            {" "}
            - {findStudent ? findStudent.fullName : `Chưa có tên`}{" "}
          </span>
        </p>
        <div className="absolute top0 right-1 top-4">
          <Button
            className=""
            severity="warning"
            type="button"
            onClick={loadData}
          >
            <img src="reload.svg" className="w-4" />
          </Button>
        </div>
      </div>

      <div className="flex gap-4 px-[8px] w-full">
        <div className="flex-[1_1_auto]">
          <InputText
            pattern="\d*"
            inputMode="numeric"
            onKeyDown={(e) => {
              if (
                !/[0-9]/.test(e.key) &&
                e.key !== "Backspace" &&
                e.key !== "Enter"
              ) {
                e.preventDefault();
              }
            }}
            onKeyUp={(e) => {
              if (e.key === "Enter") {
                if (e.target.value?.trim()) tickData(e.target.value);
                setInputData("");
              }
            }}
            ref={inputRef}
            value={inputData}
            onChange={(e) => setInputData(e.target.value)}
            placeholder="Nhập mã định danh"
            className="border flex-1 w-full"
          />
        </div>
        <div className="flex-[1_1_auto]">
          <AutoComplete
            value={valueSearch}
            onChange={(e) => setValueSearch(e.value)}
            field="fullClassName"
            onSelect={(e) => {
              tickData(e.value?.VNEDUID);
              setValueSearch("");
            }}
            placeholder="Tìm theo tên HS"
            suggestions={items}
            completeMethod={search}
          />
        </div>
        {/* <Button
          severity="success"
          type="button"
          onClick={() => {
            if (inputData?.trim()) tickData(Number(inputData));
            setInputData("");
            inputRef?.current?.focus();
          }}>
          Điểm danh
        </Button> */}
      </div>
    </div>
  );
}
export default ResultInput;
